import React from "react";
import { useBannerContent } from "./hooks";
import { MemberBenefitsLink } from "./MemberBenefitsLink/MemberBenefitsLink";
import { Separator } from "./Separator";
import { stickyFooterMemberDesktopContainer } from "./StickyFooterMemberDesktop.css";

export const StickyFooterMemberDesktop: React.FC = () => {
  const { bannerContent, showMemberBenefitsLink } = useBannerContent();
  return (
    <div
      className={stickyFooterMemberDesktopContainer}
      data-testid="StickyFooterMemberDesktop"
    >
      {bannerContent.map((text, index) => {
        return (
          <>
            {/* eslint-disable-next-line react/no-danger */}
            <div dangerouslySetInnerHTML={{ __html: text }} key={text} />
            {index !== bannerContent.length - 1 && <Separator />}
          </>
        );
      })}
      {showMemberBenefitsLink && (
        <>
          {bannerContent.length > 0 && <Separator />}
          <MemberBenefitsLink />
        </>
      )}
    </div>
  );
};
